<template>
  <h3 class="modal-header-parts" v-html="title" />
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * モーダルヘッダー テンプレート
 */
export default defineComponent({
  name: 'ModalHeaderParts',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
})
</script>

<style lang="scss" scoped>
.modal-header-parts {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  padding: 12px 24px;
  height: 44px;
  background: $white;
  border-bottom: 1px solid $black10;
  @include fontSetTextMedium();

  font-weight: 700;
}
</style>
